var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExportLine = function SvgExportLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5 6a.75.75 0 0 0-.75-.75H5.25A.75.75 0 0 0 4.5 6v12c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75zM6 14.25h2.562a3.751 3.751 0 0 0 6.876 0H18v3H6zm0-7.5h12v6h-3.75a2.25 2.25 0 1 1-4.5 0H6zm9 4.5h-2.25v2.25h-1.5v-2.25H9l3-3.375z"
  })));
};
export default SvgExportLine;